import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ConfermaComponent } from './conferma';

export const ConfermaModule: string = ng
    .module('archiSmall.userSettings.confermaModule', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('confermaComponent', ConfermaComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/usersettings/conferma/conferma.module.ts